import type { ReactNode } from 'react';
import { StatusPill } from '../../patient-files/overview/shared';
import { useStatusCatalog } from '../../../services/statusCatalog';
import { phaseColorOverride } from '../../../utils/phaseColors';

interface AppointmentStatusChipProps {
    statusId: string | null | undefined;
    className?: string;
    /** Shown instead of the chip when there's no status - rows want nothing,
     *  the detail pane wants a muted placeholder. */
    fallback?: ReactNode;
}

// Patient internal-status chip, phase-tinted like the rest of the work queue
// (see SearchDropdown's step pill) rather than StatusPill's hashed-color fallback.
export function AppointmentStatusChip({
    statusId,
    className = '',
    fallback = null
}: AppointmentStatusChipProps) {
    const catalog = useStatusCatalog();
    if (!statusId) return <>{fallback}</>;

    return (
        <StatusPill
            value={catalog.display(statusId)}
            className={className}
            colorOverride={phaseColorOverride(catalog.meta(statusId)?.phase)}
        />
    );
}
